import { render, staticRenderFns } from "./trade_apply_records.vue?vue&type=template&id=1ca5cf9a&"
import script from "./trade_apply_records.vue?vue&type=script&lang=js&"
export * from "./trade_apply_records.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports